'use client';

import React from 'react';
import { createGlobalStyle, ServerStyleSheet } from 'styled-components';

export const extractStylesFromTag = (styles: string): string => {
  try {
    return styles?.replace(/(<([^>]+)>)/gi, '');
  } catch (e) {
    console.log('ExtractStylesFromTag ERROR:', e);
    return styles;
  }
};

export const getStylesFromSheet = (sheet: ServerStyleSheet): string => {
  try {
    const tagStyles = sheet.getStyleTags();

    return extractStylesFromTag(tagStyles);
  } catch (e) {
    console.log('getStylesFromSheet ERROR:', e);
    return '';
  }
};

export const renderGlobalStyles = (styles: string): React.ReactElement => {
  const GlobalStyle = createGlobalStyle<{ styles?: string }>`
        ${props => props.styles};
      `;

  return <GlobalStyle styles={styles} />;
};

export const renderGlobalStylesFromSheet = (sheet: ServerStyleSheet): React.ReactElement => {
  const GlobalStyle = createGlobalStyle<{ styles?: string }>`
        ${props => props.styles};
      `;

  return <GlobalStyle styles={getStylesFromSheet(sheet)} />;
};

export const GlobalStyles: React.FC<{ styles: string }> = ({ styles }): React.ReactElement | null => {
  if (!styles) return null;

  const GlobalStyle = createGlobalStyle<{ styles?: string }>`
        ${props => props.styles};
      `;

  return <GlobalStyle styles={styles} />;
};

export const GlobalStylesFromSheet: React.FC<{ sheet: ServerStyleSheet }> = ({ sheet }): React.ReactElement => {
  return <GlobalStyles styles={getStylesFromSheet(sheet)} />;
};
